<template>
  <div id="coin_dealer_recharge_exchange">
     <!-- 顶部导航栏 -->
    <van-nav-bar placeholder safe-area-inset-top :title="$t('title.top_up_coins')" @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="24" class="coin_dealer_recharge_exchange_content">
        <!-- Main Tabs -->
        <div class="main-tabs">
          <div class="tab-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0"> {{ $t('column.recharge')}} </div>
          <div class="tab-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1"> {{ $t('column.exchange')}} </div>
        </div>
        <div  v-if="activeTab === 0">
          <!-- Sub Tabs -->
          <div class="sub-tabs">
            <div class="sub-tab-item" :class="{ active: activeSubTab === 0 }"  @click="activeSubTabBtn(0)">
              {{ $t('column.official')}}
              <div class="active-indicator" v-if="activeSubTab === 0"></div>
            </div>
            <div class="sub-tab-item" :class="{ active: activeSubTab === 1 }"  @click="activeSubTabBtn(1)" >
              {{ $t('column.seller')}}
              <div class="active-indicator" v-if="activeSubTab === 1"></div>
            </div>
          </div>

          <div class="content-body">
            <!-- Currency Selector -->
            <div class="currency-selector">
              <div class="currency-btn" @click="CurrencyTypeShow = true">
                <img :src="form_data.country_img" alt="" /> {{ form_data.country_name }}-{{ form_data.currency_name }} 
                <van-icon name="arrow-down" class="arrow-icon" />
              </div>
            </div>
            <div  v-if="activeSubTab === 0">
                <!-- Payment Methods Grid -->
                <div class="payment-methods-grid">
                    <div 
                    v-for="method in paymentMethods" 
                    :key="method.id"
                    class="payment-card"
                    :class="{ active: selectedPaymentMethod === method.id }"
                    @click="selectedPaymentMethodBtn(method.id)"
                    v-if="method.status"
                    >
                    <div class="payment-icon-wrapper">
                        <img v-if="method.icon" :src="method.icon" alt="" />
                    </div>
                    <span class="payment-name">{{ method.name }}</span>
                    </div>
                </div>

                <!-- Info Cards -->
                <div class="info-row">
                    <div class="info-card ratio-card">
                    <div class="card-label">{{ $t('column.recharge_ratio')}}:</div>
                    <div class="card-value">
                        1USDT= <img src="@/assets/img/coin.png" class="coin-icon" /> {{ recharge_usd_ratio }}
                    </div>
                    </div>
                    <div class="info-card network-card">
                    <div class="card-label">{{ $t('column.Network')}}:</div>
                    <div class="network-select" @click="showNetworkListBtn">
                        <span class="network-select-text">{{ selectedNetworkName || $t('column.Select_Network') }}</span>
                        <van-icon :name="showNetworkList ? 'arrow-up' : 'arrow-down'" />
                    </div>
                    </div>
                </div>

                <!-- Network List -->
                <div class="network-list" v-show="showNetworkList">
                    <div v-for="net in networks" :key="net.id" class="network-item" v-if="net.url">
                    <div class="network-left">
                        <div class="network-icon-box">
                        <img :src="net.icon" alt="" />
                        </div>
                        <span class="network-name">{{ net.name }}</span>
                    </div>
                    <button class="choose-btn" @click="selectNetwork(net)">{{ $t('column.Choose')}}</button>
                    </div>
                </div>
                <!-- 支付二维码 -->
                <div class="deposit-info-container" v-if="depositAddress">
                    <div class="notice-box">
                      <div class="notice-item">
                          <i18n path="other.deposit_notice_1" tag="span">
                              <span slot="coin" class="highlight-red">USDT</span>
                              <span slot="network" class="highlight-red">{{ selectedNetworkName }}</span>
                          </i18n>
                      </div>
                      <div class="notice-item">
                          <i18n path="other.deposit_notice_2" tag="span">
                              <span slot="amount" class="highlight-red">1 USDT</span>
                          </i18n>
                      </div>
                      <div class="notice-item">
                          {{ $t('other.deposit_notice_3') }}
                      </div>
                      <div class="notice-item">
                          {{ $t('other.deposit_notice_4') }}
                      </div>
                    </div>

                    <div class="qr-address-box">
                    <div class="qr-code-area">
                        <div ref="qrCodeUrl"></div>
                    </div>
                    <div class="address-label">{{ $t('column.Contract_address_permanently_valid') }}:</div>
                    <div class="address-text">{{ depositAddress }}</div>
                    <div class="copy-btn" @click="copyAddress">
                            <img src="../assets/img/coin_dealer/copy.png"  class="copy-icon"/>
                        <span>{{ $t('column.copy') }}</span>
                    </div>
                    </div>

                    <div>
                        <div class="tutorial_title"> <img src="../assets/img/coin_dealer/tutorial_left.png"/> {{ $t('column.top_up_tutorial') }} <img src="../assets/img/coin_dealer/tutorial_right.png"/> </div>
                        <div class="tutorial_example_title">{{ $t('column.Example_Binance_trading') }}</div>
                        <div class="tutorial_example_img">
                            <img src="../assets/img/coin_dealer/tutorial1_1.png"/>
                            <img src="../assets/img/coin_dealer/tutorial2_1.png"/>
                            <img src="../assets/img/coin_dealer/tutorial3_1.png" v-if="this.form_data.network == 'bsc'"/>
                            <img src="../assets/img/coin_dealer/tutorial3_2.png" v-else-if="this.form_data.network == 'tron'"/>
                            <img src="../assets/img/coin_dealer/tutorial3_3.png" v-else/>
                        </div>
                    </div>
                </div>
                <!-- Footer Link -->
                <div class="footer-link">
                    <span @click="OrderExceptionButton">» {{ $t('column.Top_up_customer_service') }} «</span>
                </div>
            </div>
            <div  v-else> 
                <div class="seller-list">
                    <div class="seller-card" v-for="item in sellerUserList" :key="item.id">
                        <div class="seller-header">
                            <div class="seller-info-left">
                                <div class="seller-avatar-wrapper">
                                    <img :src="item.head_image" class="seller-avatar" />
                                </div>
                                <div class="seller-text-info">
                                    <div class="seller-name-row">
                                        <span class="seller-name">{{ item.nick_name }}</span>
                                        <img :src="item.country_img" class="seller-flag" v-if="item.country_img"/>
                                    </div>
                                    <div class="seller-deal-stats">
                                        {{ $t('column.deal_of_last_30_days')}} 
                                        <span v-if="item.total_coin">
                                        <img src="../assets/img/coin11.png" /> {{ item.total_coin }}
                                      </span>
                                    </div>
                                </div>
                            </div>
                            <div class="seller-contact-right" @click="privateMessage(item.user_id)">
                                <img src="../assets/img/coin_dealer/creator_agency_message2.png" class="whatsapp-icon"/>
                            </div>
                        </div>
                        
                        <div class="seller-payment-row">
                            <span class="payment-label">{{ $t('column.payment_methood')}}:</span>
                            <div class="payment-icons-list">
                                <img v-for="(icon, idx) in item.payment_method_img" :key="idx" :src="icon.img" class="pay-icon" />
                            </div>
                        </div>
                        
                        <div class="seller-description">
                            {{ $t('column.recharge_available_host_add_agency')}}
                        </div>
                    </div>

                    
                </div>
            </div>
          </div>
        </div>
        <div  v-else> 
            <!--     exchange 兑换     -->
          <van-col span="22" offset="1" class="coin_dealer_recharge_exchange_exchange">
            <van-col span="24" class="action-content-exchange">{{ $t('column.my_beans')}}: {{ userInfo.ticket }} <img src="../assets/img/coin9.png"/> </van-col>
            <van-col span="12" class="recharge-option" @click.native="ExchangeShowBtn(0)">
              <!--   自定义兑换     -->
              <van-col span="22" offset="1" class="recharge-option-custom">{{ $t('column.custom_exchange') }} </van-col>
            </van-col>
            <van-col span="12" class="recharge-option"  v-for="(option, index) in exchangeOptions" :key="index" @click.native="exchangeOptionsSelect = index">
              <van-col span="22" offset="1" class="recharge-option-bg" :class="{'recharge-option-active': exchangeOptionsSelect === index}" >
                <van-col span="24" class="option-amount"><img src="../assets/img/coin10.png"/> {{ option.coin }}</van-col>
                <van-col span="24" class="recharge-option-bg-img" v-if="option.seller_level_img">
                  <img :src="option.seller_level_img"/>
                </van-col>
                <van-col span="24" class="option-price"><img src="../assets/img/coin9.png"/> {{ option.ticket }}</van-col>
              </van-col>
            </van-col>
            <van-col span="20" offset="2" class="recharge-btn" @click="ExchangeShowBtn(1)">
              <van-button color="#FF61F5" block round> {{ $t('column.exchange')}}</van-button>
            </van-col>
          </van-col>
        </div>
      </van-col>
      <van-overlay :show="overlayShow" z-index="3">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
       <van-popup v-model="CurrencyTypeShow" position="bottom"  round >
        <van-col span="24" class="currency_type_title"> {{ $t('column.currency_type')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1" class="currency_type_list_item" v-for="(item, index) in currency_type" :key="index" @click="currency_type_sel(item)">
            <van-col span="12" class="currency_type_list_name"> <img :src="item.country_img"/> {{ item.country_name }} </van-col>
            <van-col span="12" class="currency_type_list_item_content"> {{ item.currency_name }} <van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
      </van-popup>
        <van-popup v-model="RechargeShow" closeable position="bottom" :style="{ paddingBottom: '10vw' }" round @close="closeRechargePopup">
            <van-col span="24" class="recharge_offline_title"> {{ $t('column.recharge_offline_coins')}} </van-col>
            <van-col span="22" offset="1" class="recharge_offline_centent">
            <van-col span="24" class="recharge_offline_centent_bg" v-if="rechargeOptionsCheck.id ">
                <van-col span="8" offset="2" class="recharge_offline_centent_bg_money"> $ {{ rechargeOptionsCheck.money }} </van-col>
                <van-col span="4" class="recharge_offline_centent_bg_icon"> <van-icon name="down" /> </van-col>
                <van-col span="8" class="recharge_offline_centent_bg_coin">
                <img src="../assets/img/coin10.png"/> {{ rechargeOptionsCheck.seller_coin }}
                </van-col>
            </van-col>
            <van-col span="24" class="recharge_offline_centent_bg" v-else>
                <van-field
                    v-model="rechargeOptionsCheck.money"
                    center
                    clearable
                    @input="inputMonitorRecharge"
                >
                <template #label>
                    <van-col span="24" class="exchange_show_div_input_ticket"> $ </van-col>
                </template>
                <template #button>
                    <van-col span="24" class="exchange_show_div_input_coin">
                    <img src="../assets/img/coin10.png"/> {{ rechargeOptionsCheck.seller_coin ? rechargeOptionsCheck.seller_coin : '' }}
                    </van-col>
                </template>
                </van-field>
            </van-col>

            <van-col span="24" class="recharge_offline_method"> {{ $t('column.select_payment_method') }} </van-col>
            <van-col span="24" class="recharge_offline_method_type">
            <van-col span="16" class="recharge_offline_method_type_left">
                <img src="https://app-1371123412.cos.ap-singapore.myqcloud.com/public/image/202510/saAijbmJG3_1761127259009.png"/> Strpe
                </van-col>
                <van-col span="8" class="recharge_offline_method_type_right">
                <img src="../assets/img/recharge_offline_sel.png"/>
                </van-col>
            </van-col>
            <van-col span="24" class="recharge_offline_btn">
                <van-button color="#FF61F5" block round @click="rechargeSubmit"> {{ $t('column.recharge')}}</van-button>
            </van-col>
            </van-col>
        </van-popup>
         <van-popup v-model="ExchangeShow" position="bottom" round >
        <van-col span="24" class="exchange_show_title"> {{ $t('column.exchange_coins')}}  </van-col>
        <van-col span="24" class="exchange_show_div">
          <van-col span="22" offset="1" class="exchange_show_div_item" v-if="exchangeFrom.id">
            <van-col span="24" class="exchange_show_div_item_name" v-if="exchangeFrom.seller_level_text"> <img src="../assets/img/upgrade_img.png"/> {{ $t('column.level_up_to_seller',{name: exchangeFrom.seller_level_text })}} </van-col>
            <van-col span="24" class="exchange_show_div_item_val">
              <van-col span="11" class="exchange_show_div_item_val_name">
                <van-col span="24" class="exchange_show_div_item_val_name_coin">
                  <img src="../assets/img/coin9.png"/>
                </van-col>
                <van-col span="24" class="exchange_show_div_item_val_name_sum"> {{ exchangeFrom.ticket }} </van-col>
                <van-col span="24" class="exchange_show_div_item_val_name_title">{{ ticket_name }}</van-col>
              </van-col>
              <van-col span="2" class="exchange_show_div_item_val_centent"> <img src="../assets/img/left_jiantou.png"/> </van-col>
              <van-col span="11" class="exchange_show_div_item_val_name">
                <van-col span="24" class="exchange_show_div_item_val_name_coin">
                  <img src="../assets/img/coin10.png"/>
                </van-col>
                <van-col span="24" class="exchange_show_div_item_val_name_sum">{{ exchangeFrom.coin }} </van-col>
                <van-col span="24" class="exchange_show_div_item_val_name_title">{{ seller_currency_name }}</van-col>
              </van-col>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="exchange_show_div_input" v-else>
            <van-field
                v-model="exchangeFrom.ticket"
                center
                clearable
                @input="inputMonitor"
            >
              <template #label>
                <van-col span="24" class="exchange_show_div_input_ticket">
                  <img src="../assets/img/coin9.png"/>
                </van-col>
              </template>
              <template #button>
                <van-col span="24" class="exchange_show_div_input_coin">
                  <img src="../assets/img/coin10.png"/> {{ exchangeFrom.coin ? exchangeFrom.coin : '' }}
                </van-col>
              </template>
            </van-field>
          </van-col>
          <van-col span="22" offset="1" class="exchange_show_btn">
            <van-button color="#FABCF9" block round v-if="exchangeFrom.seller_level > 0 && userInfo.seller_level !== exchangeFrom.seller_level"> {{ $t('column.exchange')}}</van-button>
            <van-button color="#FF61F5" block round  @click="exchangeSubmit" v-else> {{ $t('column.exchange')}}</van-button>
          </van-col>
        </van-col>
      </van-popup>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import QRCode from 'qrcodejs2'
import {Toast, Dialog} from "vant";
import { judgeIosAndroid } from '@/assets/js/models.js'

export default {
  data() {
    return {
      selectedNetworkName: '',
      showNetworkList: true,
      RechargeShow: false,
      day_active: 'day',
      list: [],
      overlayShow: false,
      finished: false,
      // New UI Data
      activeTab: 0,
      activeSubTab: 0,
      selectedPaymentMethod: 'usdt',
      paymentMethods: [
        { id: 'stripe', name: 'Stripe', icon: require('../assets/img/coin_dealer/payment_methods_stripe.png'), status: 0 },
        { id: 'usdt', name: 'USDT(Crypto coin)', icon: require('../assets/img/coin_dealer/payment_methods_usdt.png'), status: 0 },
      // { id: 'usdc', name: 'USDC(Crypto coin)', icon: require('../assets/img/coin_dealer/payment_methods_usdc.png') }, // Selected by default
      ],
      networks: [
        { id: 'bsc', name: 'BNB Smart Chain(BEP20)', icon: require('../assets/img/coin_dealer/networks_bnb.png'), url: '' },
        { id: 'tron', name: 'TRON(TRC20)', icon: require('../assets/img/coin_dealer/networks_tron.png'), url: '' },
        { id: 'eth', name: 'Ethereum(ERC20)', icon: require('../assets/img/coin_dealer/networks_erc.png'), url: '' },
      ],
       CurrencyTypeShow: false,
       currency_type: [],
       form_data: {
        currency_type_id: '',
        country_img: '',
        country_name: '',
        currency_name: '',
        country_code: '',
        amount: '',
        payment_method: '',
        network: '',
       },
       depositAddress: '',
       rechargeOptionsCheck: {
        id: undefined,
        currency_type_name: undefined,
        money: undefined,
        seller_coin: undefined
      },
      seller_recharge_multiple: 0,
      recharge_usd_ratio: 0,
      recharge_payment_id: undefined,
      is_Stripe: false,
      is_usdt: false,
      sellerUserList: [],
      exchangeOptions: [],
      seller_exchange_multiple: 0,
      seller_exchange_rate: 0,
      exchangeOptionsSelect: 0,
      ExchangeShow: false,
      exchangeFrom:{},
      userInfo: {
        id: undefined,
        name: undefined,
        avatar: undefined,
        ticket: undefined,
      },
      ticket_name: '',
      seller_currency_name: '',
    }
  },
  created() {
    this.activeTab = this.$route.query.type == 2 ? 1 : 0
    this.get_list()
  },
  methods: {
    ExchangeShowBtn(type) {
      if (type === 1) {
        this.exchangeFrom = this.exchangeOptions[this.exchangeOptionsSelect]
        if (this.exchangeFrom.seller_level > 0) {
          if (this.exchangeFrom.seller_level === 1) {
            this.exchangeFrom.seller_level_text = this.$t('column.beginner_seller')
          }else{
            this.exchangeFrom.seller_level_text = this.exchangeFrom.seller_level === 2 ? this.$t('column.standard_seller') :this.$t('column.senior_seller')
          }
        }else{
          this.exchangeFrom.seller_level_text = ''
        }
      }else{
        this.exchangeFrom = {
          id: 0,
          ticket: undefined,
          coin: 0,
          seller_level: 0,
          seller_level_text: '',
        }
      }
      this.ExchangeShow =  true
    },
    privateMessage(user_id) {
      // 拦截跳转私信
      window.location.href="live://live?action=JumpUserPrivateMessage&id=" + user_id
    },
    CurrencyOfficialSelect(){
       this.sellerUserList = []
      if (this.form_data.currency_type_id) {
         const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        console.log('==============')
         console.log(this.form_data)
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_official_recharge_list",{
          params:{uid: uid, token: token, currency_type_id: this.form_data.currency_type_id,country_code: this.form_data.country_code }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if (res.data.status===1){
              this.recharge_payment_id = res.data.data.strpe_payment_id
              this.paymentMethods[0].status = res.data.data.is_Stripe ? 1 : 0;
              this.paymentMethods[1].status =  res.data.data.is_usdt ? 1 : 0;
              this.networks[0].url = res.data.data.bnb_usdt_pay ? res.data.data.bnb_usdt_pay : '';
              this.networks[1].url = res.data.data.tron_usdt_pay ? res.data.data.tron_usdt_pay : '';
              this.networks[2].url = res.data.data.eth_usdt_pay ? res.data.data.eth_usdt_pay : '';
          }else{
            this.recharge_payment_id = 0
            this.paymentMethods[0].status = 0;
            this.paymentMethods[1].status = 0;
            Toast(res.data.error)
          }
        })
      }
    },
     CurrencySellerSelect(){
      this.sellerUserList = []
      if (this.form_data.currency_type_id) {
         const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=country_seller_list",{
          params:{uid: uid, token: token, currency_type_id: this.form_data.currency_type_id }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if (res.data.status===1){
            this.sellerUserList = res.data.data.list
          }else{
            Toast(res.data.error)
          }
        })
      }
    },
    activeSubTabBtn(index) {
      if(index == 1){
        // 币商充值
        this.CurrencySellerSelect()
      }else{
        // 官方充值
        this.CurrencyOfficialSelect()
      }
      this.activeSubTab = index;
    },
    selectedPaymentMethodBtn(methodId) {
        this.selectedPaymentMethod = methodId;
        if(this.selectedPaymentMethod === 'stripe') {
            this.RechargeShow = true;
        } else {
            this.RechargeShow = false;
        }
    },
    rechargeSubmit(){
      Dialog.confirm({
        title: this.$t('Tips.buy_good_number'),
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
            // on confirm
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=seller_recharge_order",{
          params:{
            uid: uid, 
            token: token,
            payment_method_id: this.recharge_payment_id,
            payment_method_type: 1,
            recharge_id: this.rechargeOptionsCheck.id,
            money: this.rechargeOptionsCheck.money 
        }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          console.log(res.data)
          if(res.data.status===1){
            if (res.data.data.url){
              // 这个需要前端拦截打开浏览器
            //  window.open(res.data.data.url, '_blank')
              const url = res.data.data.url
              //  拦截
              const isIos = judgeIosAndroid();
              if (isIos === true) {
                // ios传值方法postMessage（val）传值方式
                window.webkit.messageHandlers.payment_redirect.postMessage(url)
              } else {
                // ios传值方法goSubmitted（val）传值方式
                window.AndroidJs.payment_redirect(url)
              }
            }else{
              Toast(res.data.error)
              this.jump_coin_seller_recharge(res.data.data.order_id)
            }
          }else{
            Toast(res.data.error)
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
    inputMonitorRecharge(value){
      let filteredValue = value.replace(/[^\d]/g, '');
      // 3. 处理大于10000的情况（向下取整到10000的倍数）
      this.rechargeOptionsCheck.seller_coin = 0
       console.log('===========')
      console.log(this.seller_recharge_multiple)
      console.log(this.recharge_usd_ratio)
      if (filteredValue) {
        let num = parseInt(filteredValue, 10);
        console.log(num)
        const exchange_multiple = parseInt(this.seller_recharge_multiple)
        let multiple_num = Math.floor(num * this.recharge_usd_ratio)
        console.log(multiple_num)
        if (multiple_num > exchange_multiple) {
          multiple_num = Math.floor(multiple_num / exchange_multiple) * exchange_multiple;
          this.rechargeOptionsCheck.seller_coin = multiple_num.toString();
        }
      }
      this.rechargeOptionsCheck.money = filteredValue;
    },
    inputMonitor(value){
      let filteredValue = value.replace(/[^\d]/g, '');
      // 3. 处理大于10000的情况（向下取整到10000的倍数）
      this.exchangeFrom.coin = 0
      if (filteredValue) {
        let num = parseInt(filteredValue, 10);
        const exchange_multiple = parseInt(this.seller_exchange_multiple)
        let multiple_num = Math.floor(num / this.seller_exchange_rate)
        if (multiple_num > exchange_multiple) {
          multiple_num = Math.floor(multiple_num / exchange_multiple) * exchange_multiple;
          this.exchangeFrom.coin = multiple_num.toString();
        }
      }
      this.exchangeFrom.ticket = filteredValue;
    },
     exchangeSubmit(){
      Dialog.confirm({
        title: this.$t('column.confirm_whether_to_exchange'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        // on confirm
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=exchange_ticket_to_coin",{
          params:{uid: uid, token: token, id: this.exchangeFrom.id, coin: this.exchangeFrom.coin, ticket: this.exchangeFrom.ticket }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          this.ExchangeShow =  false
          Toast({
            message: res.data.error,
            duration: 2000, // 持续2秒
            onClose: () => {
              // 这里写Toast关闭后要执行的方法
              this.get_list()
            }
          });

        })
      }).catch(() => {
        // on cancel
      });
    },
    closeRechargePopup() {
         this.selectedPaymentMethod = 'usdt';
        this.RechargeShow = false;
    },
    createQrCode() {
      this.$nextTick(() => {
        this.$refs.qrCodeUrl.innerHTML = "";
        new QRCode(this.$refs.qrCodeUrl, {
          text: this.depositAddress,
          width: 140,
          height: 140,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    copyAddress() {
        const el = document.createElement('textarea');
        el.value = this.depositAddress;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        Toast(this.$t('column.copy_success'));
    },
    showNetworkListBtn() {
        if (!this.showNetworkList) {
            this.selectedNetworkName = '';
            this.form_data.network = '';
            this.depositAddress = ''
        }
      this.showNetworkList = !this.showNetworkList
    },
    selectNetwork(net) { 
        const message = this.$t('column.selected_proceed_with_recharge',{name: `<span style="color: red">${net.name}</span>`})
        Dialog.confirm({
            message: message,
            allowHtml: true,
            confirmButtonColor: '#FF61F5',
            confirmButtonText: this.$t('btn.confirm'),
            cancelButtonText: this.$t('btn.cancel'),
        }).then(() => {
          // 发送请求更新地址
          const uid = this.$route.query.uid
          const token = this.$route.query.token
          axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=network_dealer_pay",{
            params:{uid: uid, token: token, net_work_type: net.id, currency_type_id: this.form_data.currency_type_id }
          }).then(res =>{
            if(res.data.status===1){
              this.selectedNetworkName = net.name;
              this.form_data.network = net.id;
              // 需要生成二维码
              this.depositAddress = net.url
              this.createQrCode()
              this.showNetworkList = false;
              // 请求三方接口更新地址
            }else{
              Toast(res.data.error)
            }
          })
        }).catch(() => {
            // 用户点击取消
        });
    },
    currency_type_sel(item){
        this.form_data.currency_type_id = item.currency_type_id
        this.form_data.country_img = item.country_img
        this.form_data.country_name = item.country_name
        this.form_data.currency_name = item.currency_name
        this.form_data.country_code = item.country_code
        try {
          localStorage.setItem('coinDealerSelectedCurrency', JSON.stringify({
            currency_type_id: this.form_data.currency_type_id,
            country_img: this.form_data.country_img,
            country_name: this.form_data.country_name,
            currency_name: this.form_data.currency_name,
            country_code: this.form_data.country_code
          }))
        } catch(e) {}
        if(this.activeSubTab === 1){
          // 查询的是币商充值
          this.CurrencySellerSelect()
        }else{
          // 币商官方充值
          this.CurrencyOfficialSelect()
        }
        this.CurrencyTypeShow = false
    },
    onClickRankingDay(name, title) {
      this.day_active = name
      this.get_list()
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    OrderExceptionButton() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/help_feedback', query: { uid: uid, token: token } });
    },
    JumpUserinfo(id) {
      console.log(id)
      if(id){
        // 拦截跳转用户主页面
        window.location.href="live://live?action=JumpUser&id=" + id
      }
    },
     get_list(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_coin_dealer_recharge",{
        params:{uid: uid, token: token }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.userInfo = res.data.data.userInfo
          this.currency_type = res.data.data.currency_type
          this.recharge_usd_ratio = res.data.data.recharge_usd_ratio
          this.seller_recharge_multiple = res.data.data.seller_recharge_multiple
          this.recharge_payment_id = 0
          this.paymentMethods[0].status = 0;
          this.paymentMethods[1].status = 0;
          this.networks[0].url = '';
          this.networks[1].url = '';
          this.networks[2].url = '';
          this.exchangeOptions = res.data.data.seller_exchange_list
          this.seller_exchange_rate = res.data.data.seller_exchange_rate
          this.seller_exchange_multiple = res.data.data.seller_exchange_multiple
          this.ticket_name = res.data.data.ticket_name
          this.seller_currency_name = res.data.data.seller_currency_name
          const cache = localStorage.getItem('coinDealerSelectedCurrency')
          if (cache) {
            try {
              const obj = JSON.parse(cache)
              this.form_data.currency_type_id = obj.currency_type_id
              this.form_data.country_img = obj.country_img
              this.form_data.country_name = obj.country_name
              this.form_data.currency_name = obj.currency_name
              this.form_data.country_code = obj.country_code
              if (this.activeSubTab === 1) {
                this.CurrencySellerSelect()
              } else {
                this.CurrencyOfficialSelect()
              }
            } catch(e) {}
          }else{
            // 出现弹框
            if (this.activeTab == 0){ 
              this.CurrencyTypeShow = true
            }
          }
        }else{
          Toast(res.data.error)
        }
      })
    }
  }
}

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/coin_dealer_recharge_exchange.vue